import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "as-match-list" }

import { computed, ref } from "vue";
import type { IMatch, ITeam, ILeague } from "~src/interfaces/tennis";
import { parseMatchH2hData } from "~src/helpers/tennis";
import ArrowDown from "~src/components/icons/ArrowDown.vue";
import MatchItem from "~src/components/matches/tennis/MatchItem.vue";

const __default__ = {};

interface IProps {
  h2h: Array<Object>;
  teams: Array<ITeam>;
  competitions: Array<ILeague> | any;
  match: IMatch;
  tab: string;
  isShowFooter: boolean;
  homeTeamId: string;
  isShowMore: number;
  mode: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'H2hTab',
  props: {
    h2h: {},
    teams: {},
    competitions: {},
    match: {},
    tab: {},
    isShowFooter: { type: Boolean, default: true },
    homeTeamId: {},
    isShowMore: { default: 0 },
    mode: { default: "vs" }
  },
  emits: ["handleIsShowMore"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const rows = computed(() => {
  return props.h2h;
});

const handleIsShowMore = (mode: string) => {
  emits("handleIsShowMore", mode);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (item, key) => {
      return (_openBlock(), _createBlock(MatchItem, {
        key: key,
        match: _unref(parseMatchH2hData)(item, _ctx.homeTeamId),
        teams: _ctx.teams,
        competitions: _ctx.competitions,
        isShowFooter: _ctx.isShowFooter,
        isH2h: true,
        session: "h2h"
      }, null, 8, ["match", "teams", "competitions", "isShowFooter"]))
    }), 128)),
    (_ctx.isShowMore == 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleIsShowMore(_ctx.mode))),
          class: "as-show-more"
        }, [
          _cache[1] || (_cache[1] = _createTextVNode(" Hiển thị thêm trận đấu ")),
          _createVNode(ArrowDown)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})